// extracted by mini-css-extract-plugin
export default {"message":"CreationFail_message__21xs-","actions":"CreationFail_actions__dyVSa"};